import { createContext, useContext, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import { Stock_Analytics } from "../../../../Configuration/API_URL";
import axiosInstance from "../../../../CommonMethhods/axiosInstance";

const clientStockContext = createContext();

export const ClientStockProvider = ({ children }) => {
  const storeToken = localStorage.getItem("ssoToken");
  const [modalOpen, setModalOpen] = useState(false);
  const [clientStockData, setClientStockData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [smallLoader, setSmallLoader] = useState(false);

  let clientCode = "";
  if (localStorage.getItem("clientCode")) {
    clientCode = localStorage.getItem("clientCode");
  }

  const fetchClientStockData = async (type, pageno) => {
    if (type === "grid" && pageno <= 1) setLoading(true);
    if (type === "excel") setSmallLoader(true);
    let payloadValue = {
      ClientCode: clientCode,
      fileType: type,
      pagesize: type === "grid" ? 10 : -1,
      pageno,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const res = await axiosInstance.post(
        Stock_Analytics.Stock_Analytics_Details,
        `"${encPayload}"`,

      );
      const response = ApiResDecrypt(res?.data);
      if (response.status === 0) {
        if (type === "grid") {
          setTotalRecords(response.data.totalCounts);
          if (pageno > 1) {
            setClientStockData((prev) => {
              return [...prev, ...response?.data?.stockList];
            });
          } else {
            setClientStockData(response?.data?.stockList);
          }
          setScrollLoader(false);
        } else {
          window.open(response?.data, "_self", "noopener,noreferrer");
        }
      } else {
        if (type !== "grid") {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setSmallLoader(false);
    }
  };

  const handleSectorClick = () => {
    setModalOpen(true);
    fetchClientStockData("grid", 1);
  };

  return (
    <clientStockContext.Provider
      value={{
        modalOpen,
        setModalOpen,
        clientStockData,
        fetchClientStockData,
        handleSectorClick,
        totalRecords,
        loading,
        smallLoader,
        setScrollLoader,
        scrollLoader,
      }}
    >
      {children}
    </clientStockContext.Provider>
  );
};

export const useClientStockContext = () => useContext(clientStockContext);
